import Entity from './Entity';

export default class Reaction implements Entity {
  constructor(public id: number, public code: string, public name: string) {}
}
